module.exports = __webpack_public_path__ + "img/brand9.c654ca04.png";